/*
* Given an array (or string separatted by commas) of mimetypes and a needed mimetype
* returns true if the needed matches the requirements
* acceptes wildcard "*", example:
* "image/*"
*/
export default function (required, needed) {
  required = typeof required === 'string' ? required.split(',') : required
  const requiredMIMETypes = required.map(MIMEType => MIMEType.split('/'))
  const neededMIMEType = (needed || '').split('/')
  let valid = false

  requiredMIMETypes.forEach(parts => {
    if (!valid && parts[0] !== '*') {
      valid = parts[0] === neededMIMEType[0]
      if (parts[1] !== '*') {
        valid = parts[1] === neededMIMEType[1]
      }
    } else if (parts[0] === '*') {
      valid = true
    }
  })

  return valid
}



// WEBPACK FOOTER //
// ./src/helpers/MIMEType.js